import axios from 'axios';
import md5 from 'js-md5';
import qs from 'qs';
const REQUEST_KEY = 'JFISABNKMSNDUGAKDKNSIU12JNF';
// const REQUEST_URL = 'http://10.82.96.130:8000/api/';
var request_url = 'http://10.82.96.130:8000/api/';
import conf from '../../static/conf.js';
if(conf){
  request_url = conf.request_url;
}
export default {
  request_url:request_url,
  get (url,data,success,error) {
    var params = this.arrToParams(data);
    axios.get(request_url + url,{params: params}).then(success).catch(error);
  },
  post (url,data,success,error) {
    var params = this.arrToParams(data);
    axios.post(request_url + url,qs.stringify(params)).then(success).catch(error);
  },
  postFile (url,data,config,success,error) {
    axios.post(request_url + url,data,config).then(success).catch(error);
  },
  sortJson (obj) {//对数组进行字典排序
    var endValue, item, key, keyArray, keyArray2, o, _i, _len;
    endValue = {};
    keyArray = [];
    keyArray2 = [];
    for (key in obj) {
      o = {};
      o[key] = obj[key];
      keyArray.push(key);
    }
    keyArray2 = keyArray.sort();
    for (_i = 0, _len = keyArray2.length; _i < _len; _i++) {
      item = keyArray2[_i];
      endValue[item] = obj[item];
    }
    return endValue;
  },
  sign (data) {
    data = this.sortJson (data);
    var str = "";
    for (var key in data) {
      str += key + '=' + data[key] + '&';
    }
    str += "key=" + REQUEST_KEY;
    return md5(str).toUpperCase();
  },
  arrToParams (arr) {
    var params = {};
    if(arr != {}){
      for(let item_ in arr){
        params[item_] = arr[item_];
      }
    }
    return params;
  },
  /**
   * 时间戳格式化函数
   * @param  {string} format    格式
   * @param  {int}    timestamp 要格式化的时间 默认为当前时间
   * @return {string}           格式化的时间字符串
   */
  date (format, timestamp) {
    var a, jsdate=((timestamp) ? new Date(timestamp*1000) : new Date());
    var pad = function(n, c){
      if((n = n + "").length < c){
        return new Array(++c - n.length).join("0") + n;
      } else {
        return n;
      }
    };
    var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var txt_ordin = {1:"st", 2:"nd", 3:"rd", 21:"st", 22:"nd", 23:"rd", 31:"st"};
    var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var f = {
      // Day
      d: function(){return pad(f.j(), 2)},
      D: function(){return f.l().substr(0,3)},
      j: function(){return jsdate.getDate()},
      l: function(){return txt_weekdays[f.w()]},
      N: function(){return f.w() + 1},
      S: function(){return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'},
      w: function(){return jsdate.getDay()},
      z: function(){return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0},

      // Week
      W: function(){
        var a = f.z(), b = 364 + f.L() - a;
        var nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
        if(b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b){
          return 1;
        } else{
          if(a <= 2 && nd >= 4 && a >= (6 - nd)){
            nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
            return date("W", Math.round(nd2.getTime()/1000));
          } else{
            return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0);
          }
        }
      },

      // Month
      F: function(){return txt_months[f.n()]},
      m: function(){return pad(f.n(), 2)},
      M: function(){return f.F().substr(0,3)},
      n: function(){return jsdate.getMonth() + 1},
      t: function(){
        var n;
        if( (n = jsdate.getMonth() + 1) == 2 ){
          return 28 + f.L();
        } else{
          if( n & 1 && n < 8 || !(n & 1) && n > 7 ){
            return 31;
          } else{
            return 30;
          }
        }
      },

      // Year
      L: function(){var y = f.Y();return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0},
      //o not supported yet
      Y: function(){return jsdate.getFullYear()},
      y: function(){return (jsdate.getFullYear() + "").slice(2)},

      // Time
      a: function(){return jsdate.getHours() > 11 ? "pm" : "am"},
      A: function(){return f.a().toUpperCase()},
      B: function(){
        // peter paul koch:
        var off = (jsdate.getTimezoneOffset() + 60)*60;
        var theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off;
        var beat = Math.floor(theSeconds/86.4);
        if (beat > 1000) beat -= 1000;
        if (beat < 0) beat += 1000;
        if ((String(beat)).length == 1) beat = "00"+beat;
        if ((String(beat)).length == 2) beat = "0"+beat;
        return beat;
      },
      g: function(){return jsdate.getHours() % 12 || 12},
      G: function(){return jsdate.getHours()},
      h: function(){return pad(f.g(), 2)},
      H: function(){return pad(jsdate.getHours(), 2)},
      i: function(){return pad(jsdate.getMinutes(), 2)},
      s: function(){return pad(jsdate.getSeconds(), 2)},
      //u not supported yet

      // Timezone
      //e not supported yet
      //I not supported yet
      O: function(){
        var t = pad(Math.abs(jsdate.getTimezoneOffset()/60*100), 4);
        if (jsdate.getTimezoneOffset() > 0) t = "-" + t; else t = "+" + t;
        return t;
      },
      P: function(){var O = f.O();return (O.substr(0, 3) + ":" + O.substr(3, 2))},
      //T not supported yet
      //Z not supported yet

      // Full Date/Time
      c: function(){return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P()},
      //r not supported yet
      U: function(){return Math.round(jsdate.getTime()/1000)}
    };

    return format.replace(/[]?([a-zA-Z])/g, function(t, s){
      if( t!=s ){
        // escaped
        return s;
      } else if( f[s] ){
        // a date function exists
        return f[s]();
      } else{
        // nothing special
        return s;
      }
    });
  },
  //上传图片的压缩处理
  // 压缩前将file转换成img对象
  readImg(img,file){
    var reader = new FileReader()
    reader.onload = function(e) {
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  },
  /**
   * 压缩图片
   *@param img 被压缩的img对象
   * @param type 压缩后转换的文件类型
   * @param mx 触发压缩的图片最大宽度限制
   * @param mh 触发压缩的图片最大高度限制
   */
  compressImg(img, type, mx, mh) {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      const { width: originWidth, height: originHeight } = img
      // 最大尺寸限制
      const maxWidth = mx
      const maxHeight = mh
      // 目标尺寸
      let targetWidth = originWidth
      let targetHeight = originHeight
      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > 1) {
          // 宽图片
          targetWidth = maxWidth
          targetHeight = Math.round(maxWidth * (originHeight / originWidth))
        } else {
          // 高图片
          targetHeight = maxHeight
          targetWidth = Math.round(maxHeight * (originWidth / originHeight))
        }
      }
      canvas.width = targetWidth
      canvas.height = targetHeight
      context.clearRect(0, 0, targetWidth, targetHeight)
      // 图片绘制
      context.drawImage(img, 0, 0, targetWidth, targetHeight)
      var dataurl = canvas.toDataURL(type || 'image/png');
      var blob = this.dataURLtoBlob(dataurl);
      return blob;
  },
  dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type:mime});
}
}



// WEBPACK FOOTER //
// ./src/utils/request.js